import { computed, Ref } from 'vue';
import { ComputedGetter, ComputedRef } from '@vue/reactivity';

export function recomputable<T>(trigger: Ref, getter: ComputedGetter<T>): ComputedRef<T> {
    return computed<T>(() => {
        trigger.value;
        return getter();
    });
}
